export default {
  reduceVisibleBy: 1,
};
